import type { SelectListUser } from '../../CreateMessage/createMessageSlice/types';
import type { Group } from '../../GroupsList/groupsSlice/types';

export type PanicButtonState = {
  selectedGroups: Group[];
  selectedUsers: SelectListUser[];
  groups: Group[];
  users: SelectListUser[];
  usersLoading: boolean;
  groupsLoading: boolean;
  isLoading: boolean;
  messageText: string;
  locationData: LocationData | null;
  alarmData: PanicAlarmData | null;
  error: string | null;
  isLocationDenied: boolean;
};

export type LocationData = {
  lat: number | null;
  lng: number | null;
  accuracy: number | undefined | null;
  name?: string | null;
  address?: string | null;
};

export type PanicAlarmData = {
  groupIds: number[];
  recipientIds: number[];
  alarmStatus: PanicAlarmState;
  text: string;
  messageId?: number;
};

export type PanicAlarmActivationData = {
  text: string;
  groupIds: number[];
  userIds: number[];
};

export enum PanicAlarmState {
  Active,
  Unlocked,
  Sent,
}
